import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { IoChevronBackCircle } from "react-icons/io5";
import Moment from 'react-moment';
import 'moment-timezone';

import ActivityLogService from '../../services/activityLog.service';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from "components/common/skeleton/AppSkeleton";
import { AppTableNoData } from "components/common/AppTableUtils";

const ActivityLogForUser = (props) => {
    const { UserName } = useParams();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });

    useEffect(() => {
        setIsLoading(true);
        ActivityLogService.getLogsForUser(UserName)
        .then(data => {
            if (data===null){
                setData([]);
            setIsLoading(false);
            }else{
            setData(data);
            setIsLoading(false);}
        }).catch(error => {
            setData([]);
            setIsLoading(false);
        })
    }, [UserName]);

    const backhandler = () => {
        props.history.goBack();
    }

    return (<>
        <div className="row justify-content-center" >
            <div className="col-12">
                <h2>Activity Log For {UserName} </h2>
            </div>
        </div>
        {isLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={4} variant="table" size="28px"/> : (
            <React.Fragment>
                <table className="table table-hover table-sm table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Sign in</th>
                            <th scope="col">Sign out</th>
                            <th scope="col">Session</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                            return (
                                <tr key={i}>
                                    <td className="col" >
                                        {item.loginDateTime !== null ? <Moment format="DD MMM yy HH:mm:ss">{item.loginDateTime}</Moment> : null}
                                    </td>
                                    <td className="col">
                                        {item.logoffDateTime !== null ? <Moment format="DD MMM yy HH:mm:ss">{item.logoffDateTime}</Moment> : null}
                                    </td>
                                    <td className="col">
                                        {item?.session}
                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {!data.length ? <AppTableNoData /> :
                        <AppPagination
                            pageSize={paginationObject.pageSize}
                            totalRecords={data.length}
                            currentPage={paginationObject.currPage}
                            endIndex={paginationObject.endIndex}
                            startIndex={paginationObject.startIndex}
                            setPaginationObject={(ele) => {
                                setPaginationObject((data) => {
                                    return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                })
                            }}
                        ></AppPagination>
                    }
            </React.Fragment>)
        }
        <AppButton action={backhandler} label="Back" icon={<IoChevronBackCircle />}></AppButton>
    </>)
}
export default ActivityLogForUser;